import * as ActionTypes from "../ActionTypes";

const initialState = {
  agentList: [{ label: "---Select---", value: "" }],
  adminList: [{ label: "---Select---", value: "" }],
  campaignNamesList: [{ label: "---Select---", value: "" }],
  campaignData: [],
  commentTableData: [],
  prospectStateEntry: false,
  campaignStateEntry: false,
  calenderStateEntry: false,
  bulkUploadEntry: false,
  dashboardEntry: true,
  Authrelation: [{ label: "---Select---", value: "" }],
  salesreplist: [],
  status: { status: "", message: "", errorMessage: "" },
  mailzipCodes: [],
  appointments:[],
  campaignOwnerNamesList:[]
};
export default function CampaignProspectReducer(state = initialState, action) {
  // 28Cases
  switch (action.type) {
    case ActionTypes.CAMPAIGN_LIST:
      return {
        ...state,
        campaignData:
          action.payload.data.length > 0
            ? [...initialState.campaignData, ...action.payload.data]
            : initialState.campaignData,
      };
    case ActionTypes.GET_AGENT_IN_FORM:
      return {
        ...state,
        salesreplist: [
          ...[{ label: "---Select---", value: "" }],
          ...action.payload.data,
        ],
      };
    case ActionTypes.GET_AGENT_LIST:
      return {
        ...state,
        agentList: [
          ...[{ label: "---Select---", value: "" }],
          ...action.payload.data,
        ],
        adminList:
          action.payload.data &&
          action.payload.data.filter(
            (admin) =>
              admin.userRole === "SUPER_USER" ||
              admin.userRole === "AGENCY_ADMIN"
          ),
      };
    case ActionTypes.LOAD_PROSPECT_ROW:
      return {
        ...state,
        prospectrowData: action.payload.data,
      };
    case ActionTypes.CLEAR_PROSPECT_ROW_DATA:
      return {
        ...state,
        prospectrowData: [],
      };
    case ActionTypes.LOAD_DEMOGRAPHICS: {
      return {
        ...state,
        demographicsData: action.payload.data,
      };
    }
    case ActionTypes.SET_CAMPAIGN_PROSPECT_STATE_PARAMS: {
      return {
        ...state,
        [action.payload.type]: action.payload.data,
      };
    }
    case ActionTypes.LOAD_SOA: {
      return {
        ...state,
        SOAData: action.payload.data,
      };
    }
    case ActionTypes.SAVE_PROSPECT:
    case ActionTypes.SAVE_CALLS:
    case ActionTypes.DIGITAL_SIGN:
      return {
        ...state,
      };
    case ActionTypes.SAVE_SOA_DATA: {
      return {
        ...state,
        leadIdNbr: action.payload.data,
      };
    }
    case ActionTypes.GET_CALLS_DATA:
      return {
        ...state,
        callsTableData: action.payload.data,
      };
    case ActionTypes.GET_CALLS_DATA_ROWSELECT: {
      return {
        ...state,
        callsRowData: action.payload.data,
      };
    }
    case ActionTypes.GET_COMMENTS_DATA: {
      return {
        ...state,
        commentTableData: action.payload.data,
      };
    }
    case ActionTypes.ADD_NEW_COMMENT: {
      return {
        ...state,
        nwCmtResponseData: action.payload.data,
      };
    }
    case ActionTypes.SET_PROSPECT_STATE: {
      return {
        ...state,
        prospectStateEntry: action.payload,
      };
    }
    case ActionTypes.SET_CAMPAIGN_STATE: {
      return {
        ...state,
        campaignStateEntry: action.payload,
      };
    }
    case ActionTypes.SET_CALENDER_STATE: {
      return {
        ...state,
        calenderStateEntry: action.payload,
      };
    }
    case ActionTypes.SEARCH_PROSPECT:
      let data = action.payload.data;
      data.map((x) => (x.checked = "N"));
      return {
        ...state,
        prospectTableData: data,
      };
    case ActionTypes.SET_CALLER_ID: {
      return {
        ...state,
        callerID: action.payload,
      };
    }
    case ActionTypes.SET_LEAD_ID: {
      return {
        ...state,
        leadIdNbr: action.payload.leadIdNbr,
        selectedData: action.payload,
      };
    }
    case ActionTypes.GET_CAMPAIGN_NAMES:
      return {
        ...state,
        campaignNamesList: action.payload.data,
      };
    case ActionTypes.CLEAR_PROSPECT_DATA:
      return {
        ...state,
        prospectrowData: [],
        demographicsData: "",
        selectedData: "",
        leadIdNbr: "",
      };
    case ActionTypes.CLEAR_SOA_DATA:
      return {
        ...state,
        SOAData: "",
      };
    case ActionTypes.GET_AUTH_RELATIONS:
      return {
        ...state,
        Authrelation: action.payload.data
          ? [
              ...initialState.Authrelation,
              ...Object.keys(action.payload.data).map((value, i) => {
                const label = Object.values(action.payload.data)[i];
                return { label: label, value: value };
              }),
            ]
          : initialState.Authrelation,
      };
    case ActionTypes.GET_MAILZIPCODES:
      return {
        ...state,
        mailstateCd:
          action.payload.data.length === 0
            ? ""
            : action.payload.data[0].stateCode,
        mailstateId:
          action.payload.data.length === 0
            ? ""
            : action.payload.data[0].stateCd,
        mailcityName:
          action.payload.data.length === 0
            ? ""
            : action.payload.data[0].cityName,
        mailzipCodes:
          action.payload.data.length === 0 ? [] : action.payload.data,
      };
    case ActionTypes.ASSIGN_PROSPECT:
      return {
        ...state,
        status: {
          status: action.payload.status,
          message: action.payload.data,
          errorMessage: action.payload.message,
        },
      };
      case ActionTypes.FETCH_APPOINTMENTS:{
        let pointdata=action.payload.data??[]
        pointdata.forEach((p,i)=>{
          let pointDate=p["appointmentDate"]?.split("-");
          p["appointmentDate"]=`${pointDate[1]}/${pointDate[2]}/${pointDate[0]}`
        })
        return {
          ...state,
          appointments:pointdata,
        }
      }

      case ActionTypes.GET_CAMPAIGN_OWNER_NAMES:
          
      return {
        ...state,
         campaignOwnerNamesList:action.payload.data
      };
    default:
      return state;
  }
}
